import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  andAllWhere,
  andWhere,
  buildQuery,
  FilterFn,
  noop,
  Ops,
  orderBy,
  OrderVariant,
  orWhere,
  page,
  where,

} from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import { HttpClient } from "@angular/common/http";
import {
  IPagination,
  IPaginationResult,
  IRequestResult,
} from "../../../../common/interfaces";
import { environment as env } from "../../../../../environments/environment.prod";
import { AbstractService } from "../../../../services/abstract.service";
import RouteGroupAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/routing/route-group/route-group.entity";
import { LogMiddlewareServiceAttributes, LogMiddlewareServiceDetailAttributes } from "@albatrosdeveloper/ave-models-package";

const apiUrl = env.API_AVE_INTEGRATOR_URL;
const moduleName = "log_middleware_service";
const moduleNameDetail = "log_middleware_service_detail"

@Injectable({
  providedIn: "root",
})
export class SystemLatencyService extends AbstractService<
  RouteGroupAttributes,
  LogMiddlewareServiceAttributes,
  LogMiddlewareServiceAttributes
> {
  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findAllWithCount(
    options: IPagination<LogMiddlewareServiceAttributes>,
    companyId,
    date,
    status
  ): Observable<IPaginationResult<LogMiddlewareServiceAttributes>> {

    const query = buildQuery<LogMiddlewareServiceAttributes>(
      where('_deleted', Ops.eq(false)),
      andWhere("code", Ops.like(options.search ?? "", "i")),
      orWhere("name", Ops.like(options.search ?? "", "i")),
      andAllWhere("dateStart", Ops.btwnDates(date.start, date.end)),
      companyId ? andAllWhere('company.id' as keyof LogMiddlewareServiceAttributes, Ops.eq(companyId)) : noop(),

      status && status.length > 0 ?
        andAllWhere(
          "status",
          Ops.in(...status)
        )
        : noop(),

      orderBy(
        options.sort ?? "dateStart",
        options.sortDirection == "ASC" ? OrderVariant.Asc : OrderVariant.Desc
      ),
      page(options.currentPage ?? 1, options.limitPerPage ?? 100)
    );

    const API_URL: string = apiUrl + `api/${moduleName}/withCount?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IPaginationResult<LogMiddlewareServiceAttributes>>(API_URL);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findAllWithCounts(
    options: IPagination<LogMiddlewareServiceAttributes>,
    companyId?,
    date?
  ): Observable<IPaginationResult<LogMiddlewareServiceAttributes>> {

    const query = buildQuery<LogMiddlewareServiceAttributes>(
      where('_deleted', Ops.eq(false)),
      andWhere("code", Ops.like(options.search ?? "", "i")),
      orWhere("name", Ops.like(options.search ?? "", "i")),
      andAllWhere("dateStart", Ops.btwnDates(date.start, date.end)),
      companyId && companyId.length > 0 ? andAllWhere('company.id' as keyof LogMiddlewareServiceAttributes, Ops.eq(companyId)) : noop(),

      orderBy(
        options.sort ?? "dateStart",
        options.sortDirection == "ASC" ? OrderVariant.Asc : OrderVariant.Desc
      ),
      page(options.currentPage ?? 1, options.limitPerPage ?? 100)
    );

    const API_URL: string = apiUrl + `api/${moduleName}/withCount?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IPaginationResult<LogMiddlewareServiceAttributes>>(API_URL);
  }

  findById(id: string): Observable<IRequestResult<LogMiddlewareServiceAttributes>> {
    const API_URL: string = apiUrl + `api/${moduleName}/byId/${id}`;
    return this.http.get<IRequestResult<LogMiddlewareServiceAttributes>>(API_URL);
  }

  updateSS(id: number, data: any) {
    const API_URL = `http://168.197.69.179:2052/api/pm_middleware_ws/put/${id}`
    return this.http.put<any>(API_URL, data)
  }

  sincronize(id) {
    const API_URL = `http://168.197.69.179:2052/api/pm_middleware_ws/put/${id}`
    return this.http.get<any>(API_URL)
  }

  //detail
  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findAllDetailWithCount(
    options: IPagination<LogMiddlewareServiceDetailAttributes>,
    id: LogMiddlewareServiceDetailAttributes
  ): Observable<IPaginationResult<LogMiddlewareServiceDetailAttributes>> {

    const hasSearch = !!options.search;
    
            /**
             * Construye las condiciones base que SIEMPRE deben aplicarse.
             * Incluye: _deleted=false, filtros de distribución, oficina, estado, fechas.
             *
             * @param useOrWhere - Si es true, inicia un nuevo objeto con orWhere (para el OR lógico)
             */
            const buildBaseFilters = (params: { useOrWhere: boolean }): FilterFn<LogMiddlewareServiceDetailAttributes>[] => {
                const deletedFilter: FilterFn<LogMiddlewareServiceDetailAttributes> = params.useOrWhere
                    ? orWhere('_deleted', Ops.eq(false))  // Inicia nuevo objeto en el array
                    : where('_deleted', Ops.eq(false));   // Primer objeto del array

                  const filters: FilterFn<LogMiddlewareServiceDetailAttributes>[] = [deletedFilter];
    
                return filters;
            };

            const searchByAssetNameQueryObject: FilterFn<LogMiddlewareServiceDetailAttributes>[] = [
                        ...buildBaseFilters({ useOrWhere: false }),
                        hasSearch ? andWhere("documentIdentifier", Ops.like(options.search!, "i")) : noop()
                    ];

           const searchByMessageQueryObject: FilterFn<LogMiddlewareServiceDetailAttributes>[] = hasSearch ? [
                ...buildBaseFilters({ useOrWhere: true }),
                andWhere("message", Ops.like(options.search!, "i"))
              ] : [];

    const query = buildQuery<LogMiddlewareServiceDetailAttributes>(
      ...searchByAssetNameQueryObject,
      ...searchByMessageQueryObject,

      orderBy(
        options.sort ?? "createdAt",
        options.sortDirection == "ASC" ? OrderVariant.Asc : OrderVariant.Desc
      ),
      page(options.currentPage ?? 1, options.limitPerPage ?? 100)
    );

    const API_URL: string = apiUrl + `api/${moduleNameDetail}/byLog/${id}?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IPaginationResult<LogMiddlewareServiceDetailAttributes>>(API_URL);
  }

  findAllDetailWithCount2(
    options: IPagination<LogMiddlewareServiceDetailAttributes>,
    data: any
  ): Observable<IPaginationResult<LogMiddlewareServiceDetailAttributes>> {
    const arrayQueries: FilterFn<any>[] = [];
    
    if (!data.type) {
      arrayQueries.push(where('_deleted', Ops.eq(false)))
    }

    const query = buildQuery<LogMiddlewareServiceDetailAttributes>(
      ...arrayQueries,
      andWhere('documentIdentifier', Ops.eq(data.documentIdentifier)),

      orderBy(
        options.sort ?? "createdAt",
        options.sortDirection == "ASC" ? OrderVariant.Asc : OrderVariant.Desc
      ),
      page(options.currentPage ?? 1, options.limitPerPage ?? 100)
    );

    const API_URL: string = apiUrl + `api/${moduleNameDetail}/withCount?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IPaginationResult<LogMiddlewareServiceDetailAttributes>>(API_URL);
  }
}
